import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "fileInput", "fileGroup"];

  connect() {
    this.toggleFileGroup();
  }

  toggleCheckbox() {
    if (this.fileInputTarget.files.length > 0) {
      this.checkboxTarget.checked = false;
    }
  }

  toggleFileInput() {
    if (this.checkboxTarget.checked) {
      this.fileInputTarget.value = "";
    }
    this.toggleFileGroup();
  }

  toggleFileGroup() {
    if (this.checkboxTarget.checked) {
      this.fileGroupTarget.classList.add("hidden");
    } else {
      this.fileGroupTarget.classList.remove("hidden");
    }
  }
}
